import {
  DEVICE_SUMMARY_FETCH,
  DEVICE_SUMMARY_FETCH_SUCCESS,
  DEVICE_SUMMARY_FETCH_FAIL,
  DEVICE_FETCH,
  DEVICE_FETCH_SUCCESS,
  DEVICE_FETCH_FAIL,
  MACHINE_TYPE_FETCH,
  MACHINE_TYPE_FETCH_SUCCESS,
  MACHINE_TYPE_FETCH_FAIL,
  CREATE_NEW_MACHINE,
  CREATE_NEW_MACHINE_SUCCESS,
  CREATE_NEW_MACHINE_FAIL,
  UPDATE_DEVICE_PROFILE,
  UPDATE_DEVICE_PROFILE_SUCCESS,
  UPDATE_DEVICE_PROFILE_FAIL,
  DEVICE_DETAIL_FETCH,
  DEVICE_DETAIL_FETCH_SUCCESS,
  DEVICE_DETAIL_FETCH_FAIL,
  DEVICE_ONOFFLINE_FETCH,
  DEVICE_ONOFFLINE_FETCH_SUCCESS,
  DEVICE_ONOFFLINE_FETCH_FAIL
} from '../actions';

export const deviceSummaryFetch = (deviceSummary) => ({
  type: DEVICE_SUMMARY_FETCH,
  payload: { deviceSummary }
});

export const deviceSummarySuccess = (deviceSummary) => ({
  type: DEVICE_SUMMARY_FETCH_SUCCESS,
  payload: { deviceSummary }
});

export const deviceSummaryFail = (message) => ({
  type: DEVICE_SUMMARY_FETCH_FAIL,
  payload: { message }
});


export const deviceFetch = (device, history) => ({
  type: DEVICE_FETCH,
  payload: { device, history }
});

export const deviceSuccess = (device) => ({
  type: DEVICE_FETCH_SUCCESS,
  payload: { device }
});

export const deviceFail = (message) => ({
  type: DEVICE_FETCH_FAIL,
  payload: { message }
});

export const machineTypeFetch = (machineType) => ({
  type: MACHINE_TYPE_FETCH,
  payload: { machineType }
});

export const machineTypeSuccess = (machineType) => ({
  type: MACHINE_TYPE_FETCH_SUCCESS,
  payload: { machineType }
});

export const machineTypeFail = (message) => ({
  type: MACHINE_TYPE_FETCH_FAIL,
  payload: { message }
});

export const createMachine = (machineCreate) => ({
  type: CREATE_NEW_MACHINE,
  payload: { machineCreate }
});

export const createMachineSuccess = (machineCreate) => ({
  type: CREATE_NEW_MACHINE_SUCCESS,
  payload: { machineCreate }
});

export const createMachineFail = (message) => ({
  type: CREATE_NEW_MACHINE_FAIL,
  payload: { message }
});

export const updateDeviceProfile = (profile) => ({
  type: UPDATE_DEVICE_PROFILE,
  payload: { profile }
});

export const updateDeviceProfileSuccess = (profile) => ({
  type: UPDATE_DEVICE_PROFILE_SUCCESS,
  payload: { profile }
});

export const updateDeviceProfileFail = (message) => ({
  type: UPDATE_DEVICE_PROFILE_FAIL,
  payload: { message }
});

export const deviceDetailFetch = (deviceDetail) => ({
  type: DEVICE_DETAIL_FETCH,
  payload: { deviceDetail }
});

export const deviceDetailFetchSuccess = (deviceDetail) => ({
  type: DEVICE_DETAIL_FETCH_SUCCESS,
  payload: { deviceDetail }
});

export const deviceDetailFetchFail = (message) => ({
  type: DEVICE_DETAIL_FETCH_FAIL,
  payload: { message }
});

export const deviceOnlineOfflineFetch = (deviceOnlineOffline) => ({
  type: DEVICE_ONOFFLINE_FETCH,
  payload: { deviceOnlineOffline }
});

export const deviceOnlinOfflineSuccess = (deviceOnlineOffline) => ({
  type: DEVICE_ONOFFLINE_FETCH_SUCCESS,
  payload: { deviceOnlineOffline }
});

export const deviceOnlinOfflineFail = (message) => ({
  type: DEVICE_ONOFFLINE_FETCH_FAIL,
  payload: { message }
});
